module.exports = __webpack_public_path__ + "media/images/federal-child-tax-credit-for-single-parent-two-children-f233b66aec1fec3eba060e9416884faa.png";